import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  // Paper,
  Typography,
  Paper,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { setSelectedBudgetBrands } from "../../../../../features/engagementIncentivesSlice";
import { useDispatch } from "react-redux";

export default function BrandsSelection() {
  const columns = ["Brand name", "QFTD Cost", "QFTD Budget"];
  const [selectAll, setSelectAll] = useState(false);
  const dispatch = useDispatch();
  const query1Data = useSelector(
    (state: any) => state.engagementIncentives?.query1Data?.query_output || []
  );
  const query2Data = useSelector(
    (state: any) => state.engagementIncentives?.query2Data?.query_output || []
  );

  const query3Data = useSelector(
    (state: any) => state.engagementIncentives?.query3Data?.query_output || []
  );
  const selectedBudgetBrands = useSelector(
    (state: any) => state.engagementIncentives?.selectedBudgetBrands || []
  );

  const [checkedBrands, setCheckedBrands] = useState<any[]>([]);
  const validRows = useMemo(
    () =>
      query1Data.filter(
        (row: any) => row.qftd_budget !== 0 && row.cost_per_qftd !== null
      ),
    [query1Data]
  );

  const handleCheckboxChange = (row: any) => {
    let updated;
    const exists = checkedBrands.some(
      (item) => item.shared_uid === row.shared_uid
    );

    if (exists) {
      updated = checkedBrands.filter(
        (item) => item.shared_uid !== row.shared_uid
      );
    } else {
      const {
        shared_uid,
        qftd_budget,

        cost_per_qftd,
        brand_name,
      } = row;
      updated = [
        ...checkedBrands,
        { shared_uid, qftd_budget, cost_per_qftd, brand_name },
      ];
    }

    setCheckedBrands(updated);

    // Create custom structure
    const customData = updated?.map((brand) => {
      const linksForBrand = query2Data.filter(
        (item: any) =>
          item.incentivized_traffic_budget_shared_uid === brand.shared_uid
      );

      const linkDetails = linksForBrand
        .map((link: any) => {
          const match = query3Data.find(
            (item: any) => item.link_shared_uid === link.link_shared_uid
          );
          return match
            ? {
                link_shared_uid: match.link_shared_uid,
                shown_in_active_table: match.shown_in_active_table,
                link_name: match.link_name,
              }
            : null;
        })
        .filter(Boolean); // Remove nulls
      const brand_shared_uid = query3Data.find((item: any) =>
        linksForBrand.some(
          (link: any) => link.link_shared_uid === item.link_shared_uid
        )
      )?.brand_shared_uid;
      const allBrandLinks = query3Data.filter(
        (item: any) => item.brand_shared_uid === brand_shared_uid
      );
      const existingLinkUids = new Set(
        linkDetails?.map((ld: any) => ld.link_shared_uid)
      );
      const linkDetailsFromBrand = allBrandLinks
        .filter((link: any) => !existingLinkUids.has(link.link_shared_uid))
        ?.map((link: any) => ({
          link_shared_uid: link.link_shared_uid,
          shown_in_active_table: link.shown_in_active_table,
          link_name: link.link_name,
        }));
      return {
        budget_shared_uid: brand.shared_uid,
        brand_name: brand.brand_name,
        link_details: linkDetails,
        link_details_from_brand: linkDetailsFromBrand,
        brand_shared_uid: brand_shared_uid || null,
        qftd_budget: brand.qftd_budget,
        cost_per_qftd: brand.cost_per_qftd,
      };
    });
    dispatch(setSelectedBudgetBrands(customData));
  };

  const handleSelectAllChange = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    if (newSelectAll) {
      const selected = validRows?.map(
        ({
          shared_uid,
          qftd_budget,

          cost_per_qftd,
          brand_name,
        }: any) => ({
          shared_uid,
          qftd_budget,

          cost_per_qftd,
          brand_name,
        })
      );

      setCheckedBrands(selected);

      const customData = selected.map((brand: any) => {
        const linksForBrand = query2Data.filter(
          (item: any) =>
            item.incentivized_traffic_budget_shared_uid === brand.shared_uid
        );

        const linkDetails = linksForBrand
          .map((link: any) => {
            const match = query3Data.find(
              (item: any) => item.link_shared_uid === link.link_shared_uid
            );
            return match
              ? {
                  link_shared_uid: match.link_shared_uid,
                  shown_in_active_table: match.shown_in_active_table,
                  link_name: match.link_name,
                }
              : null;
          })
          .filter(Boolean); // Remove nulls

        const brand_shared_uid = query3Data.find((item: any) =>
          linksForBrand.some(
            (link: any) => link.link_shared_uid === item.link_shared_uid
          )
        )?.brand_shared_uid;
        const allBrandLinks = query3Data.filter(
          (item: any) => item.brand_shared_uid === brand_shared_uid
        );

        const existingLinkUids = new Set(
          linkDetails.map((ld: any) => ld.link_shared_uid)
        );

        const linkDetailsFromBrand = allBrandLinks
          .filter((link: any) => !existingLinkUids.has(link.link_shared_uid))
          .map((link: any) => ({
            link_shared_uid: link.link_shared_uid,
            shown_in_active_table: link.shown_in_active_table,
            link_name: link.link_name,
          }));
        return {
          budget_shared_uid: brand.shared_uid,
          brand_name: brand.brand_name,
          link_details: linkDetails,
          brand_shared_uid: brand_shared_uid || null,
          qftd_budget: brand.qftd_budget,
          link_details_from_brand: linkDetailsFromBrand,
          cost_per_qftd: brand.cost_per_qftd,
        };
      });

      dispatch(setSelectedBudgetBrands(customData));
    } else {
      setCheckedBrands([]);
      dispatch(setSelectedBudgetBrands([]));
    }
  };

  useEffect(() => {
    setSelectAll(
      checkedBrands.length > 0 && checkedBrands.length === validRows.length
    );
  }, [checkedBrands, validRows]);
  useEffect(() => {
    // Restore checkbox state from Redux
    const restored = selectedBudgetBrands.map((item: any) => ({
      shared_uid: item.budget_shared_uid,
      qftd_budget: item.qftd_budget,

      cost_per_qftd: item.cost_per_qftd,
      brand_name: item.brand_name,
    }));
    setCheckedBrands(restored);
    // eslint-disable-next-line
  }, []);

  return (
    <TableContainer sx={{ mt: 3 }}>
      <Typography>Selected Brands</Typography>
      <Paper sx={{ maxHeight: 270, overflow: "auto" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                {validRows.length === 0 ? (
                  <Checkbox color="secondary" checked={false} disabled />
                ) : (
                  <Checkbox
                    color="secondary"
                    checked={selectAll}
                    onChange={handleSelectAllChange}
                    indeterminate={
                      checkedBrands.length > 0 &&
                      checkedBrands.length < validRows.length
                    }
                  />
                )}
              </TableCell>
              {columns?.map((col, index) => (
                <TableCell key={index} sx={{ padding: "8px" }}>
                  <Typography fontWeight={500}>{col}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {validRows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center">
                  <Typography color="textSecondary" sx={{ paddingRight: 16 }}>
                    Nothing to show here because all entries either have a
                    budget of 0 or missing cost information !
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              validRows?.map((row: any, rowIndex: number) => (
                <TableRow key={rowIndex}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      color="secondary"
                      checked={checkedBrands.some(
                        (item) => item.shared_uid === row.shared_uid
                      )}
                      onChange={() => handleCheckboxChange(row)}
                    />
                  </TableCell>
                  <TableCell sx={{ padding: "8px" }}>
                    {row.brand_name}
                  </TableCell>
                  <TableCell sx={{ padding: "8px" }}>
                    {row.cost_per_qftd}
                  </TableCell>
                  <TableCell sx={{ padding: "8px" }}>
                    {row.qftd_budget}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Paper>
    </TableContainer>
  );
}
